import { Grid, makeStyles } from "@material-ui/core";
import React from "react";

import { TEXT_DEFAULT } from "../../styles/colors";
import { FONT_MED } from "../../styles/fonts";
import { isEmptyValue } from "../../utils";

interface SectionCardRowProps {
  label: React.ReactNode;
  value: React.ReactNode;
  className?: string;
  dataTestId?: string;
}

export default function SectionCardRow({
  label,
  value,
  className = "",
  dataTestId,
}: SectionCardRowProps) {
  const classes = useStyles();
  if (isEmptyValue(value)) return null;
  return (
    <Grid
      container
      alignItems="flex-start"
      className={`${classes.row} ${className}`}
      data-testid={dataTestId}
    >
      <Grid item xs={5} className={classes.label}>
        <span className={classes.labelText}>{label}</span>
      </Grid>
      <Grid item xs={7} className={classes.value}>
        {typeof value === "string" ? (
          <span className={classes.valueText}>{value}</span>
        ) : (
          value
        )}
      </Grid>
    </Grid>
  );
}

const useStyles = makeStyles(() => ({
  row: {
    minHeight: 20,
  },
  label: {
    paddingRight: 8,
    minWidth: 0,
    wordBreak: "break-word",
  },
  labelText: {
    fontSize: 14,
    lineHeight: "20px",
    letterSpacing: "0.25px",
    color: TEXT_DEFAULT,
    ...FONT_MED,
  },
  value: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-end",
    textAlign: "right",
    gap: "4px 8px",
    minWidth: 0,
    "& > *": {
      minWidth: 0,
      maxWidth: "100%",
      wordBreak: "break-word",
      overflowWrap: "anywhere",
    },
  },
  valueText: {
    fontSize: 14,
    lineHeight: "18px",
    ...FONT_MED,
  },
}));
